import { render, staticRenderFns } from "./entrustChildVideo.vue?vue&type=template&id=172e0ddc&scoped=true"
import script from "./entrustChildVideo.vue?vue&type=script&lang=js"
export * from "./entrustChildVideo.vue?vue&type=script&lang=js"
import style0 from "./entrustChildVideo.vue?vue&type=style&index=0&id=172e0ddc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172e0ddc",
  null
  
)

export default component.exports